import React from "react";
import { PawPrint, Gem, CheckCircle2 } from "lucide-react";
import Reveal from "../Reveal";

const leftList = ["Behavior Therapy", "Surgery Service", "Emergency Support", "Grooming Session"];
const rightList = ["Rehabilitation Therapy", "Senior Care", "Lab Diagnostics", "Microchip Implant"];

const About = () => {
  return (
    <section className="mx-auto max-w-[1290px] px-5 py-20 md:py-28">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        {/* Image collage */}
        <div className="relative">
          <Reveal animation="fadeInLeft">
            <img
              src="/pawelle/img_17-1.jpg"
              alt="Veterinarian caring for a pet"
              className="w-full rounded-[28px] object-cover shadow-[0_24px_60px_rgba(67,48,109,0.12)]"
            />
          </Reveal>

          {/* Flip box */}
          <Reveal
            animation="fadeInDown"
            delay={200}
            className="pw-flip absolute -bottom-10 left-6 hidden h-44 w-64 sm:block"
          >
            <div className="pw-flip-inner h-full w-full shadow-[0_20px_50px_rgba(67,48,109,0.2)]">
              <div className="pw-flip-face bg-pawelle-primary text-center text-white">
                <Gem className="mb-3 h-9 w-9" />
                <p className="font-display text-[17px] font-semibold leading-tight">Your Partner in Pet Wellness</p>
                <p className="mt-2 font-body text-[13px] text-white/80">
                  Est ornare condimentum magnis auctor cras libero scelerisque.
                </p>
              </div>
              <div className="pw-flip-face pw-flip-back bg-pawelle-ink text-center text-white">
                <p className="font-display text-[17px] font-semibold leading-tight">Your Partner in Pet Wellness</p>
                <p className="mt-2 font-body text-[13px] text-white/80">
                  Laoreet natoque dapibus donec aenean purus metus dolor. Nam odio in conubia nisl posuere.
                </p>
              </div>
            </div>
          </Reveal>

          {/* Experience badge + secondary image */}
          <div className="mt-6 grid grid-cols-2 gap-5">
            <Reveal animation="fadeInUp" delay={150} className="flex flex-col items-center justify-center rounded-[24px] bg-pawelle-primary px-6 py-8 text-center text-white shadow-[0_18px_40px_rgba(114,82,155,0.3)]">
              <span className="font-display text-[46px] font-bold leading-none text-white">25+</span>
              <span className="mt-2 font-body text-[15px] font-semibold text-white/90">Years Of Experience</span>
            </Reveal>
            <Reveal animation="fadeInRight" delay={200}>
              <img
                src="/pawelle/img_14.jpg"
                alt="Pet under care"
                className="h-full w-full rounded-[24px] object-cover shadow-[0_18px_40px_rgba(67,48,109,0.12)]"
              />
            </Reveal>
          </div>
        </div>

        {/* Text */}
        <div>
          <Reveal animation="rubberBand">
            <span className="inline-flex items-center gap-2 font-display text-[15px] font-semibold text-pawelle-primary">
              <PawPrint className="h-5 w-5" />
              Who We Are
            </span>
          </Reveal>
          <Reveal animation="fadeInUp" delay={100}>
            <h2 className="mt-4 max-w-xl font-display text-[30px] font-bold leading-tight text-pawelle-ink md:text-[38px]">
              Providing Gentle, Expert Care for Every Companion
            </h2>
          </Reveal>
          <div className="my-6 h-px w-full bg-pawelle-ink/10" />
          <Reveal animation="fadeInUp" delay={150}>
            <p className="font-body text-[16px] leading-relaxed text-pawelle-body">
              You can trust us to be honest, transparent and realistic in our communications with you. We will never
              sell you products you don't need or prolong treatment unnecessarily. The Moggies & Doggies team has over
              thirty years of experience in general practice, and we work hard to keep our knowledge, treatments and
              equipment up to date.
            </p>
          </Reveal>

          <div className="mt-8 grid grid-cols-1 gap-x-8 gap-y-4 sm:grid-cols-2">
            {[...leftList, ...rightList].map((item, i) => (
              <Reveal key={item} animation="fadeInUp" delay={100 + i * 60}>
                <div className="flex items-center gap-3 font-body text-[16px] font-semibold text-pawelle-ink">
                  <CheckCircle2 className="h-5 w-5 flex-shrink-0 text-pawelle-primary" />
                  {item}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
